module.exports = __webpack_public_path__ + "static/media/fundo.270efe48.jpg";